"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LanguageContext = /*#__PURE__*/_react["default"].createContext({
  lang: 'en',
  changeLanguage: function changeLanguage() {}
});

var _default = LanguageContext;
exports["default"] = _default;